import { loadFiltersForReport } from 'utils/filter';
import * as C from 'actions/constants';

export const blankState = {
  isOpen: false,
  data: {},
};

const FilterReducer = (state = blankState, action) => {
  switch (action.type) {
    case C.LOAD_REPORT_SUCCESS: {
      const { data: { report: { id } } } = action;
      const filters = loadFiltersForReport(id);

      return { ...state, data: filters };
    }
    case C.CLOSE_REPORT: {
      return { ...state, data: {} };
    }
    case C.TOGGLE_FILTER: {
      return { ...state, isOpen: !state.isOpen };
    }
    case C.SET_FILTERS: {
      return { ...state, data: action.data };
    }
    case C.LOAD_FILTERS: {
      return { ...state, data: action.data };
    }
    default:
      return state;
  }
};

export default FilterReducer;
